import { Incident } from 'models/Blip/Incident';
import { BaseRequest } from './BaseRequest';

export class IncidentRequest extends BaseRequest {
    incident: Incident | null;
    constructor(incident: Incident | null) {
        super();
        this.incident = incident;
    }
}